/**
 * React hook to initialize the CSRF token after authentication.
 * Call this in the authenticated app shell (not the root — login page doesn't need CSRF).
 */

import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { initCsrfToken } from '../utils/fetchWithCsrf';

/**
 * Initialize CSRF token when the user is authenticated.
 */
export function useCsrfToken(): void {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      initCsrfToken();
    }
  }, [isAuthenticated]);
}
